import { useState, useEffect } from "react";

import { useDisclosure } from "@chakra-ui/react";

import { Link } from "react-scroll";

import {
  Drawer,
  DrawerBody,
  DrawerContent,
} from "@chakra-ui/react";

import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";

import {
  StyledMenuSection,
  StyledHeader,
  StyledMenuIconsSection,
} from "./styles";

import NavBar from "../components/navBar";
import SocialMediaIcons from "../components/SocialMediaIcons";
import HomeContent from "../components/homeContent";
import AboutMe from "../components/AboutMe";
import MyTechStack from "../components/MyTechStack";
import ProjectsSection from "../components/ProjectsSection";
import Footer from "../components/Footer";
import Logo from "../components/Logo";
import FormContact from "../components/FormContact";

function Home() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [placement, setPlacement] = useState("right");

  const [windowSize, setWindowSize] = useState(getWindowSize());

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <>
      {windowSize.innerWidth > 977 ? (
        <>
          <StyledHeader name="header">
            <Logo />
            <StyledMenuIconsSection>
              <NavBar />
              <SocialMediaIcons />
            </StyledMenuIconsSection>
          </StyledHeader>
          <HomeContent />
          <AboutMe />
          <MyTechStack />
          <ProjectsSection />
          <FormContact/>
          <Footer />
        </>
      ) : (
        <>
          <StyledMenuSection>
            <Logo />
            <AiOutlineMenu className="menuIcon" onClick={onOpen} />
          </StyledMenuSection>
          <HomeContent />
          <AboutMe />
          <MyTechStack />
          <ProjectsSection />
          <FormContact/>
          <Footer />
        </>
      )}

      <Drawer placement={placement} onClose={onClose} isOpen={isOpen} >
        <DrawerContent>
          <div className="closeMenuDiv">
            <AiOutlineClose className="menuIcon" onClick={onClose} />
          </div>
          <DrawerBody  >
            <Link to="about" spy={true} smooth={true} offset={50} duration={500} >
              <p className="menuListItem" onClick={onClose}>_sobre-mim</p>
            </Link>
            <Link to="stack" spy={true} smooth={true} offset={50} duration={500} >
              <p className="menuListItem" onClick={onClose}>_tech-stack</p>
            </Link>
            <Link to="projects" spy={true} smooth={true} offset={50} duration={500} >
              <p className="menuListItem" onClick={onClose}>_projetos</p>
            </Link>
            <Link to="contact" spy={true} smooth={true} offset={50} duration={500} >
              <p className="menuListItem" onClick={onClose}>_contato</p>
            </Link>
            <SocialMediaIcons />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default Home;
